import { IFrameModal } from '@/components/modal'
import { ProfileMenu } from '@/components/profile-menu'
import { ROUTE_ACCESSED_LOGGED, ROUTE_LOGIN, ROUTE_SIGNUP } from '@/constants/Routes'
import { useAppSelector } from '@/hooks/useRedux'
import { authSelector } from '@/pages/auth/selectors'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { tabletMenus } from './Menu'

type Props = {
  toggleShowDropdown: () => void
}

export const TabletHeader = ({ toggleShowDropdown }: Props) => {
  const { t } = useTranslation()

  const { token } = useAppSelector(authSelector)
  const [openIframe, setOpenIframe] = useState(false)

  const onToggleIframe = () => setOpenIframe(!openIframe)

  return (
    <>
      <div className="px-16 py-6 bg-white md:flex lg:hidden hidden justify-center relative">
        {tabletMenus.map((item) => {
          if (item.public && !item.href && item.title === 'Run Events')
            return (
              <div
                key={item.title}
                className={`p-4 text-primary-700 cursor-pointer hover:text-primary-900 font-semibold capitalize font-sans text-sm mx-4 px-2 py-1 w-[64px] flex items-center text-center`}
                onClick={onToggleIframe}
              >
                {t(`common.${item.title}`)}
              </div>
            )
          if (item.public && item.href)
            return (
              <Link
                key={item.href}
                to={item.href}
                className={`p-4 text-primary-700 hover:text-primary-900 font-semibold capitalize font-sans text-sm mx-4 px-2 py-1 w-[64px] flex items-center text-center`}
              >
                {t(`common.${item.title}`)}
              </Link>
            )

          if (token && !item.public && ROUTE_ACCESSED_LOGGED.includes(item.href) && item.href)
            return (
              <Link
                key={item.href}
                to={item.href}
                className={`p-4 text-primary-700 hover:text-primary-900 font-semibold capitalize font-sans text-sm mx-4 px-2 py-1 w-[64px] flex items-center text-center`}
              >
                {t(`common.${item.title}`)}
              </Link>
            )

          if (!token && !item.public && item.href === ROUTE_LOGIN && item.href)
            return (
              <Link
                to={item.href}
                key={item.href}
                className={`p-4 text-primary-700 hover:text-primary-900 font-semibold capitalize font-sans text-sm mx-4 px-2 py-1 w-[64px] flex items-center text-center border-primary-700 border rounded`}
              >
                {t(`common.${item.title}`)}
              </Link>
            )

          if (!token && !item.public && item.href === ROUTE_SIGNUP && item.href)
            return (
              <Link
                key={item.href}
                to={item.href}
                className={`p-4 text-white font-semibold capitalize font-sans text-sm mx-4 px-2 py-1 w-[64px] flex items-center text-center rounded bg-azul`}
              >
                {t(`common.${item.title}`)}
              </Link>
            )

          return <React.Fragment key={item.href} />
        })}
        {token && <ProfileMenu imgClass="w-10 h-10" toggleShowDropdown={toggleShowDropdown} />}
      </div>
      <IFrameModal open={openIframe} onClose={onToggleIframe} />
    </>
  )
}
